import mixitup from 'mixitup';

const containerEl = document.querySelector('.news-overview__news');
if (containerEl) {
    let mixer = mixitup(containerEl, {});
}
